import { createContext, useContext } from "react";

const ColorSelected = createContext();

export default ColorSelected;